/**
 * MetricStrip.jsx — Horizontal row of metric cards with shared visual hierarchy.
 *
 * Default = inline cards separated by 1px hairlines (premium feel).
 * Pass an array of metric objects matching <MetricCard/> props.
 *
 * Example:
 *   <MetricStrip
 *     metrics={[
 *       { label: 'Overall Support', value: '63%', sublabel: 'Policy Acceptance', tone: 'positive' },
 *       { label: 'Net Reaction', value: '+18', sublabel: 'favorable − unfavorable', tone: 'positive' },
 *       ...
 *     ]}
 *   />
 */
import { cn } from '../../lib/utils';
import MetricCard from './MetricCard';

export default function MetricStrip({
  metrics = [],
  className,
  testId = 'metric-strip',
  cols,
}) {
  if (!metrics || metrics.length === 0) return null;

  // Default to one column per metric, capped at 5 for readability.
  const count = Math.min(metrics.length, 5);
  const colsCls = cols || `grid-cols-2 md:grid-cols-${count}`;

  return (
    <div
      className={cn(
        'grid gap-px bg-slate-200/80 dark:bg-border rounded-xl overflow-hidden border border-slate-200 dark:border-border',
        colsCls,
        className
      )}
      data-testid={testId}
    >
      {metrics.map((m, i) => (
        <MetricCard
          key={m.label || i}
          label={m.label}
          value={m.value}
          sublabel={m.sublabel}
          tone={m.tone}
          size={m.size || 'md'}
          icon={m.icon}
          testId={m.testId || `${testId}-item-${i}`}
        />
      ))}
    </div>
  );
}
